export default class Keys {
  constructor (source, q) {
    this.source = source
    this.q = q

    this.GetKeys = (identifier) => {
      const defer = q.defer()
      this.source.SendRequest('GET', 'keys', { identifier }).then((rta) => {
        defer.resolve(rta)
      }).catch((err) => {
        defer.reject(err)
      })
      // retornamos la promesa
      return defer.promise
    }
  }
}
